import { createSlice } from "@reduxjs/toolkit";

const initialCourse = {
  name: ""
};

const initialCoursesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null,
  course: initialCourse
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const courseSlice = createSlice({
  name: "courses",
  initialState: initialCoursesState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getCourses
    coursesFetched: (state, action) => {
      const { isSuccess, type, totalCount, entity, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
      state.parentCourse = entity && entity.parentCourse;
    },
    //getCourse
    courseFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.course = action.payload.entity;
    },
    //completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    //cleanCoursesState
    coursesStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.totalCount = 0;
      state.entities = [];
      state.course = initialCourse;
    }
  }
});